import React from 'react';
import { Typography } from '@mui/material';
import CodeMirror from "@uiw/react-codemirror";
import { markdown } from "@codemirror/lang-markdown";
import "katex/dist/katex.min.css";

interface LatexActionProps {
    actionValue: any;
    result: any
}
export default function LatexAction({ actionValue, result }: LatexActionProps) {
    console.log({ result, actionValue })


    if (actionValue?.length === 0) {
        return <Typography>No label available.</Typography>;
    }
    return (
        <>
            {actionValue.map((value: any, valueIndex: any) => (
                <>
                    <div key={valueIndex} style={{ height: "100vh", backgroundColor: "#fff", color: "#000", display: "flex", flexDirection: "column" }}>
                        <Typography sx={{ fontWeight: 'bold', marginRight: '20px' }}>
                            {value.config_details?.value?.title}:
                        </Typography>
                        <div style={{ display: "flex", flex: 1, overflow: "auto" }}>
                            <div style={{ flex: 1, borderRight: "2px solid #ccc", padding: "10px", overflow: "auto" }}>
                                <h3 style={{ margin: 0, color: "#333" }}>Code Editor</h3>
                                <CodeMirror
                                    value={value?.latexCode || ""}
                                    height="85vh"
                                    extensions={[markdown()]}
                                />
                            </div>

                            <div style={{ flex: 1, padding: "10px", overflowY: "auto" }}>
                                <h3 style={{ color: "#66ff99" }}>Output</h3>
                                {value?.latex ? (
                                    <iframe
                                        src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(value?.latex)}`}
                                        style={{ width: "100%", height: "100%", border: "none" }}
                                        title="PDF Preview"
                                    />
                                ) : (
                                    <p style={{ color: "#ccc" }}>No PDF to preview</p>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            ))}
        </>
    );
}
